import {
  FETCH_SEARCH_DETAILS,
  FETCH_SEARCH_DETAILS_SUCCESS,
  QUICK_TELLER_USER
} from "./actions/constant";

const saveSearch = JSON.parse(sessionStorage.getItem("searchDetails"));
const initialState = {
  search: saveSearch != null ? saveSearch : [],
  userDetails: null,
  loading: false,
};

function searchReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SEARCH_DETAILS: {
      return {
        ...state,
        loading: true,
      };
    }

    case FETCH_SEARCH_DETAILS_SUCCESS: {
      sessionStorage.setItem("searchDetails", JSON.stringify(action.payload));
      return {
        ...state,
        loading: false,
        search: action.payload,
      };
    }

   case QUICK_TELLER_USER: {
      return {
        ...state,
        userDetails: action.payload,
      };
    }

    default:
      return state;
  }
}

export default searchReducer;
